import { Core } from "@/core/Core";

export default {

  async getSale(context, {saleId, augment, dto}) {
    try {
      return await Core.request("GET", `/api/sale/${saleId}`, {augment, dto});
    } catch (e) {
      return null;
    }
  },

  async getPosSaleAsSale(context, {saleId, augment}) {
    try {
      return await Core.request("GET", `/api/pos_sales/${saleId}/as_sale`, {augment});
    } catch (e) {
      return null;
    }
  },

  async getInvoice(_, { invoiceNumber, company }) {
    try {
      return await Core.request("GET", `/api/invoices/${invoiceNumber}?company=${company}`);
    } catch (e) {
      return null;
    }
  },

  async screenPendingSales(context, queryParams) {
    try {
      return await Core.request("GET", "/api/secure/screen", queryParams);
    } catch (e) {
      logToFile("ERROR /api/secure/screen " + JSON.stringify(e));
      return null;
    }
  },

  async screenConfirmSale(context, saleId) {
    try {
      return await Core.request("PUT", "/api/secure/screen/sale-modify", [{
        "id": saleId,
        "isReceived": true
      }]);
    } catch (e) {
      logToFile("ERROR /api/secure/screen/sale-modifier for SALE " + saleId + " - " + JSON.stringify(e));
      return null;
    }
  },

  updateSaleStatus(context, {saleId, status, message, moreData}) {
    try {
      return  Core.request("PUT",  "/api/secure/screen/sale-update-status", {
        "id": saleId,
        'mdResponse': {'status': status, 'message': message},
        'moreData' : moreData
      });
    } catch (e) {
      logToFile("ERROR /api/secure/screen/sale-update-status for SALE " + saleId + " - " + JSON.stringify(e));
      return null;
    }
  },

  async screenSaleHistory(context, {offset, perPage}) {
    try {
      return await Core.request("GET", `/api/secure/sale/company/history/${offset}/${perPage}`);
    } catch (e) {
      return null;
    }
  },

  async getSalesOfCompany(context, {companyId, query}) {
    try {
      return await Core.request("GET", `/api/companies/${companyId}/sales`, query);
    } catch (e) {
      return null;
    }
  },

  async getSaleInventoryItems(context, {saleId}) {
    try {
      return await Core.request("GET", "/api/sale/" + saleId + "/items_up_to_date");
    } catch (e) {
      return null;
    }
  },

  async saveSale(context, {saleId, data}) {
    try {
      return await Core.request("PUT", `/api/sale/${saleId}`, data);
    } catch (e) {
      return null;
    }
  },

  async massSaveSale(context, {data}) {
    try {
      return await Core.request("PUT", '/api/sale_mass', data);
    } catch (e) {
      return null;
    }
  },
}
